import { put } from 'core/middlewares/utilities';
import { user } from 'core/use-cases';

export function* userInit() {
  yield put(user.actions.userFetch.request());
}
